<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card
      shadow="always"
      :body-style="{ padding: '20px' }"
    >
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/build' }">党建专栏</el-breadcrumb-item>
        <el-breadcrumb-item>党建详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>中办印发《通知》在全党开展深入贯彻中央八项规定精神学习教育</h2>
        <p style="text-align: right"><span
            style="margin-right: 60px">2025-03-17</span></p>
        <p>近日，中共中央办公厅印发《关于在全党开展深入贯彻中央八项规定精神学习教育的通知》（以下简称《通知》）。</p>
        <p>
          《通知》指出，为贯彻落实党的二十届三中全会部署，巩固拓展学习贯彻习近平新时代中国特色社会主义思想主题教育成果，巩固深化党纪学习教育成果，锲而不舍落实中央八项规定精神，推进作风建设常态化长效化，经党中央同意，在全党开展深入贯彻中央八项规定精神学习教育（以下简称“学习教育”）。学习教育于2025年全国两会后启动、7月底前基本结束。
        </p>
        <p>
          《通知》明确，要坚持以习近平新时代中国特色社会主义思想为指导，持续深化党的创新理论武装，组织全党认真学习领会习近平总书记关于加强党的作风建设的重要论述，学习领会和贯彻落实中央八项规定及其实施细则精神，系统总结党的十八大以来深入贯彻中央八项规定精神取得的显著成效，集中整治违反中央八项规定及其实施细则精神的突出问题，运用由风及腐案例加强警示教育，引导党员、干部锤炼党性、提高思想觉悟，密切党群干群关系，以作风建设新成效推动保持党的先进性纯洁性、不断赢得人民群众信任拥护，为进一步全面深化改革、推进中国式现代化提供有力保障。
        </p>
        <p>
          《通知》强调，坚持聚焦主题、简约务实，不分批次、不划阶段，一体推进学查改，融入日常、抓在经常。学习研讨要组织学习习近平总书记关于加强党的作风建设的重要论述和中央八项规定及其实施细则精神，总结学习深入贯彻中央八项规定精神的成效和经验，提高认识、增强信心，坚定不移抓好落实。查摆问题要通过对标对表查摆，充分运用纪检监察、巡视巡察、审计监督、财会监督、督促检查、调查研究、信访反映等途径，全面深入查找落实中央八项规定及其实施细则精神方面存在的问题。集中整治要坚持有什么问题就解决什么问题，什么问题突出就重点整治什么问题，立查立改、即知即改。开门教育要注重群众参与，接受群众监督，各级领导干部要带头走好新时代党的群众路线，组织党员、干部立足岗位，在推动高质量发展、加强基层治理、完成急难险重任务中担当作为、服务群众，让群众可感可及。
        </p>
        <p>
          《通知》要求，各级党委（党组）要对本地区本部门本单位学习教育负总责，党委（党组）主要负责同志要担负起第一责任人责任，紧密结合中心工作，精心组织实施，加强分类指导，做好宣传引导，坚决反对形式主义。
        </p>
        <p>(来源:新华社)</p>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
        >
          <span style="cursor: pointer; color: #666; font-size: 14px">
            &nbsp;&nbsp;&nbsp;&nbsp;
            <!-- &lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;又踏层峰辟新天——《中共中央关于进一步全面深化改革、推进中国式现代化的决定》... -->
          </span>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build10' })"
          >中央八项规定精神学习专题&nbsp;&nbsp;&nbsp;&nbsp;下一条
            &gt;</span>
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.kongxi {
  height: 10px;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }

  .blue01 {
    font-weight: bold;
    color: #000080;
  }
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}
</style>